import ModuleBootstrapper from '../common/ModuleBootstrapper/ModuleBootstrapper';

import ListShipmentManifests from './containers/ListShipmentManifests';

const routes = [
    {
        type: 'simple',
        name: 'list',
        path: '/shipment-manifests',
        view: ListShipmentManifests
    }
]

export default ModuleBootstrapper.getRoutes("shipment-manifests", routes)
